<template>
<div>
    <ac-modal :title="'Available Plans'" ref="modalRef">
        <div class="info-board info-board-blue">
            The plans below are part of a shared offering that can be edited 
            <a @click.prevent="goToPlanOffering">here</a>
        </div>
        <table class="mdl-data-table table table-responsive dataTable no-footer dtr-inline" width="100%">
            <thead class="ajaxTitle">
            <tr class="ajaxTitle">
                <th width="40%">Plan Name</th>
                <th width="20%">Membership Frequencies</th>
                <th width="20%">Plan Price</th>
                <th width="20%">Discount</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="p in availablePlans" :key="p.planId">
                <td class="name">
                    <a href="#" class="cursor-pointer" @click.prevent="()=>viewPlanDetails(p)">
                        {{ p.planName }}
                    </a>
                    <upcoming-plan-changes :plan-id="p.planId">
                        <template slot-scope="contProps">
                            <span class="label label-warning" style="cursor: pointer"
                                    v-if="contProps.hasPendingChange">
                                <span>
                                    <i class="fa fa-info-circle"></i> Changing
                                </span>
                            </span>
                        </template>
                    </upcoming-plan-changes>
                </td>
                <td>
                    {{ p.frequencies }}
                </td>
                <td class="name">
                    <a href="#" @click.prevent="()=>viewPriceTierSummaryModal(p)">Show Prices</a>
                </td>
                <td class="name"><a href="#" @click.prevent="()=>viewDiscountModal(p)">View Discounts</a></td>
            </tr>
            </tbody>
        </table>
    </ac-modal>
    <ac-auto-reset-modal :path="'components/shared/physicianProfileAndPlans/PlanDetailsModal.vue'" ref="viewDetailsModal">

    </ac-auto-reset-modal>
    <ac-auto-reset-modal ref="addDiscountModal" :read-only="true" :path="'components/shared/providers/plans/PlanDiscountModal.vue'">

    </ac-auto-reset-modal>
    <ac-auto-reset-modal ref="priceTierSummaryModal" :path="'components/shared/providers/plans/PriceTiers/PriceTiersSummaryModal.vue'">

    </ac-auto-reset-modal>
</div>
</template>

<script>
    import {api} from "../../../../global/framework/api.js";
    import UpcomingPlanChanges from "../../../../components/shared/physicianProfileAndPlans/UpcomingPlanChanges.vue";

    export default {
        name: "AvailablePlans",
        components: {UpcomingPlanChanges},
        data() {
            return {
                widgetReady: false,
                consultantId: null,
                companyId: null,
                companyName: '',
                planPoolId: null,
                availablePlans: []
            };
        },
        methods: {
            async showModal({consultantId, companyId}) {
                this.widgetReady = false;
                this.consultantId = consultantId;
                this.companyId = companyId;
                let data = await api.getDataWithTwoIds(
                    'MediatorPlan', this.consultantId, 'GetAvailableCompanyPlansWithPriceTiers', this.companyId);

                // console.log("AvailablePlans showModal consultantId, data:", data);
                this.companyName = data.name;
                this.planPoolId = data.planPoolId;
                this.availablePlans = data.plans;
                this.widgetReady = true;
                this.$refs.modalRef.open();
            },
            goToPlanOffering() {
                // console.log("AvailablePlans goToPlanOffering planPoolId:", this.planPoolId);
                let args = {consultantId: this.consultantId, planPoolId: this.planPoolId};
                this.$router.push({name: "editPlanOffering", params: args});
            },
            viewPlanDetails(plan) {
                this.$refs.viewDetailsModal.showModal(plan.planId);
            },
            viewDiscountModal(plan) {
                let discountPlanInfo = {
                    discounts: [],
                    planId: plan.planId
                }
                this.$refs.addDiscountModal.showModal(discountPlanInfo);
            },
            viewPriceTierSummaryModal(plan) {
                this.$refs.priceTierSummaryModal.showModal({planId: plan.planId, companyId: this.companyId});
            }
        }
    }
</script>

<style scoped>

</style>